angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/base.html',
    '<div class="ui-base">\n' +
    '	<div ui-view />\n' +
    '</div>');
}]);
